import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
const ICloseTask = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill={props.color ?? '#37474F'}
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.159 7.21966C12.4519 6.92677 12.9268 6.92677 13.2197 7.21966C13.5126 7.51256 13.5126 7.98743 13.2197 8.28032L11.3107 10.1893L13.2803 12.159C13.5732 12.4519 13.5732 12.9268 13.2803 13.2197C12.9874 13.5126 12.5126 13.5126 12.2197 13.2197L10.25 11.25L8.28033 13.2197C7.98744 13.5126 7.51257 13.5126 7.21967 13.2197C6.92678 12.9268 6.92678 12.4519 7.21967 12.159L9.18934 10.1893L7.28033 8.28032C6.98744 7.98743 6.98744 7.51256 7.28033 7.21966C7.57323 6.92677 8.0481 6.92677 8.34099 7.21966L10.25 9.12867L12.159 7.21966Z"
              fill={props.color ?? '#37474F'}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z"
              fill={props.color ?? '#37474F'}
            />
          </svg>
        );
      }}
      {...props}
    />
  );
};

export default ICloseTask;
